import { Injectable } from '@angular/core';
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';
import customerJson from "../../../assets/config/customer.json";

@Injectable()
export class Formvalidator {

    formValidation: any;
    enableDigitalXmlExport:boolean = customerJson.settings.enableDigitalXmlExport;

    /**
     * Constructor
     */
    constructor() {
        this.setDefault();
    }    

    /**
     * Set default values
     */
    setDefault() {
        this.formValidation = {        
           controlReasonTextError: false,
           purposeTextError: false,
           titleError: false,
           recieverPersonError: false,
           //phoneError: false,
           classificationErrror: false,
           rkAttachmentEstimatedAssests: false,
           rkAttachmentTotalDeptError: false,
           suaOrganisationError: false,
           suaProjectError: false,
           orgNrOperatorError: false,
           orgNrSupervisorError: false,
           operatorNameError: false,
           operatorUnitShortCodeError: false,
           adressCodeOperator: false,
           adressCodeSupervisor: false,
           rkCauseError: false,
           rkCountryOfBirthError: false,
           rkCityOfBirthError: false,
           rkPastCitizenError: false,
           rkOtherPostalAddressError: false,
           rkOtherPostalCodeError: false,
           rkOtherPostalCityError: false,
           rkOtherAddressError: false,
           rkLatestAddressAbroadError: false,
           rkAddressField1Error: false,
           rkAddressField2Error: false,
           rkAddressField3Error: false,
           rkNameClarificationError: false,
           rkSsnError: false,
           rkPersonLastnameError: false,
           rkpersonFirstNameError: false,
           rkPhoneDaytimeError: false,
           rkPassportNumberError: false
        }
    }    

    /**
     * Only used when digital xml export is activated
     * Validates that the operator organisation number is set
     */
    validateOrgNrOperator(orgNrOperator: string) {
        if (orgNrOperator == null || orgNrOperator.trim().length < 1) {
            this.formValidation.orgNrOperatorError = false;
        } else if (!this.validateOrgId(orgNrOperator)){
            this.formValidation.orgNrOperatorError = true;           
        } else {
            this.formValidation.orgNrOperatorError = false;
        }
        return !this.formValidation.orgNrOperatorError;
    }

     /**
     * Validates that the supervisor organisation number is set
     */
      validateOrgNrSupervisor(orgNrSupervisor: string) {
        if (orgNrSupervisor == null || orgNrSupervisor.trim().length < 1) {
            this.formValidation.orgNrSupervisorError = false;
        } else if (!this.validateOrgId(orgNrSupervisor)){
            this.formValidation.orgNrSupervisorError = true;           
        } else {
            this.formValidation.orgNrSupervisorError = false;
        }
        return !this.formValidation.orgNrSupervisorError;
    }

    /**
     * Validate organisation id
     * @param id employer name from form
     */
     validateOrgId(id) {
        if(id === null || id === "" || id === undefined) {           
            return false;
        }

        if (id.length > 11) {
            return false;
        }

        if(id.charAt(0) === '2' || id.charAt(0) === '3' || id.charAt(0) === '5' || id.charAt(0) === '6') {
            if(!(id.trim().replace(/\D/g, "").length === 10)) {                
                return false;
            }
        }

        id = id.match(/[0-9]{6}-[0-9]{4}/g);
            if(id === null){                
                return false;
            } else {
                id = id[0];
            }

            id = id
            .replace(/\D/g, "")     // strip out all but digits
            .split("")              // convert string to array
            .reverse()              // reverse order for Luhn

            // verify we got 10 digits, otherwise it is invalid
            if (id.length != 10) {               
                return false;
            }

            var sum = id
                // convert to number
                .map(function(n) {
                    return Number(n);
                })
                // perform arithmetic and return sum
                .reduce(function(previous, current, index) {
                    // multiply every other number with two
                    if (index % 2) current *= 2;
                    // if larger than 10 get sum of individual digits (also n-9)
                    if (current > 9) current -= 9;
                    // sum it up
                    return previous + current;
                });

            // sum must be divisible by 10   
            if (0 === sum % 10) {
                return true;   
            } 

        return false;
    }

    /**
     * Validate swedish social security number
     * @param ssn social security number    
     */
     validateSsn(ssn) {      
        
        if (ssn === null || ssn === "") {
            return false;     
        }
       
        ssn = ssn.match(/[0-9]{8}-[0-9]{2}([0-9]{2}|TF)/g);
        if(ssn === null) {            
            return false;
        } else {
            ssn = ssn[0];
        }
        if(ssn.slice(-2) === "TF") {            
            return true;
        } else {
            ssn = ssn
            .replace(/\D/g, "")     // strip out all but digits
            .split("")              // convert string to array
            .reverse()              // reverse order for Luhn
            .slice(0, 10);          // keep only 10 digits (i.e. 1977 becomes 77)

            // verify we got 10 digits, otherwise it is invalid
            if (ssn.length != 10) {      
                return false;
            }

            var sum = ssn
                // convert to number
                .map(function(n) {
                    return Number(n);
                })
                // perform arithmetic and return sum
                .reduce(function(previous, current, index) {
                    // multiply every other number with two
                    if (index % 2) current *= 2;
                    // if larger than 10 get sum of individual digits (also n-9)
                    if (current > 9) current -= 9;
                    // sum it up
                    return previous + current;
                });

            // sum must be divisible by 10   
            if (0 === sum % 10) {                          
                return true;     
            } else {                   
                return false;     
            }
        }       
    }

    /**
     * Validate SSN in register control
     * @param ssn 
     * @returns 
     */
    validateRkSsn(ssn: string) {
        if (!this.validateSsn(ssn)) {
            return this.formValidation.rkSsnError = true;
        } else {
            return this.formValidation.rkSsnError = false             
        }
    }


    /**
     * Only used when digital xml export is activated
     * Validates that the operator organisation name is set
     */
    validateOperatorName(operatorName: string){
        if(operatorName == null || operatorName.trim().length < 2){
            this.formValidation.operatorNameError = true;          
        } else {
            this.formValidation.operatorNameError = false;
        }
        return !this.formValidation.operatorNameError;
    }

    /**
     * Only used when digital xml export is activated
     * Validates that the operator unit short code is set
     */
    validateOperatorUnitShortCode(adressCodeOperator: string) {    
        if(adressCodeOperator == null || adressCodeOperator.trim().length < 1) {            
            return this.formValidation.operatorUnitShortCodeError = false; 
        } else if (adressCodeOperator.trim().length < 2) {
            return this.formValidation.operatorUnitShortCodeError = true;
        } 
        return this.formValidation.operatorUnitShortCodeError = false;
    }

    /**
     * Validate length for rkCause
     * @param rkCause 
     * @returns 
     */
    validateRkCause(rkCause: string) {
        if (rkCause === null || rkCause.trim().length < 1) {
            return this.formValidation.rkCauseError = false;
        } else if (rkCause.trim().length < 2) {
            return this.formValidation.rkCauseError = true;
        }
        return this.formValidation.rkCauseError = false;
    }

    /**
     * Validate country of birth
     * @param countryOfBirth 
     * @returns 
     */
    validateRkCountryOfBirth(countryOfBirth: string) {
        if (countryOfBirth === null || countryOfBirth.trim().length < 1) {
            return this.formValidation.rkCountryOfBirthError = false;
        } else if (countryOfBirth.trim().length < 2) {
            return this.formValidation.rkCountryOfBirthError = true;
        }
        return this.formValidation.rkCountryOfBirthError = false;
    }

    /**
     * Validate city of birth
     */
    validateRkCityOfBirth(cityOfBirth: string) {
        if (cityOfBirth === null || cityOfBirth.trim().length < 1) {
            return this.formValidation.rkCityOfBirthError = false;
        } else if (cityOfBirth.trim().length < 2) {
            return this.formValidation.rkCityOfBirthError = true;
        }
        return this.formValidation.rkCityOfBirthError = false;
    }

    /**
     * Validate past citizen
     * @param pastCitizen 
     * @returns 
     */
    validateRkPastCitizen(pastCitizen: string) {
        if (pastCitizen === null || pastCitizen.trim().length < 1) {
            return this.formValidation.rkPastCitizenError = false;
        } else if (pastCitizen.trim().length < 2) {
            return this.formValidation.rkPastCitizenError = true;
        }
        return this.formValidation.rkPastCitizenError = false;
    }

    /**
     * Validate other postal address
     * @param otherPostalAddress 
     * @returns 
     */
    validateRkOtherPostalAddress(otherPostalAddress: string) {
        if (otherPostalAddress === null || otherPostalAddress.trim().length < 1) {
            return this.formValidation.rkOtherPostalAddressError = false;
        } else if (otherPostalAddress.trim().length < 2) {
            return this.formValidation.rkOtherPostalAddressError = true;
        }
        return this.formValidation.rkOtherPostalAddressError = false;
    }

    /**
     * Validate intenational home postal code
     * @param postCode post code number
     */
    validateRkOtherPostalCode(postCode: any) {
        if (postCode === null || postCode.trim().length < 1) {
            return this.formValidation.rkOtherPostalCodeError = false;
        } else if (postCode.trim().length < 2) {
            return this.formValidation.rkOtherPostalCodeError = true;           
        } 
        return this.formValidation.rkOtherPostalCodeError = false;
    }

    /**
     * Validate other postal city
     * @param otherPostalCity 
     * @returns 
     */
    validateRkOtherPostalCity(otherPostalCity: string) {
        if (otherPostalCity === null || otherPostalCity.trim().length < 1) {
            return this.formValidation.rkOtherPostalCityError = false;
        } else if (otherPostalCity.trim().length < 2) {
            return this.formValidation.rkOtherPostalCityError = true;
        }
        return this.formValidation.rkOtherPostalCityError = false;
    }

    /**
     * Validate other address
     * @param otherAddress 
     * @returns 
     */
    validateRkOtherAddress(otherAddress: string) {
        if (otherAddress === null || otherAddress.trim().length < 1) {
            return this.formValidation.rkOtherAddressError = false;
        } else if (otherAddress.trim().length < 2) {
            return this.formValidation.rkOtherAddressError = true;
        }
        return this.formValidation.rkOtherAddressError = false;
    }

    validateRkLatestAddressAbroad(latestAddressAbroad: string) {
        if (latestAddressAbroad === null || latestAddressAbroad.trim().length < 1) {
            return this.formValidation.rkLatestAddressAbroadError = false;
        } else if (latestAddressAbroad.trim().length < 2) {
            return this.formValidation.rkLatestAddressAbroadError = true;
        }
        return this.formValidation.rkLatestAddressAbroadError = false;
    }

    /**
     * Validate latest address postal code abroad
     * @param addressField1 
     * @returns 
     */
    validateRkAddressField1(addressField1: string) {
        if (addressField1 === null || addressField1.trim().length < 1) {
            return this.formValidation.rkAddressField1Error = false;
        } else if (addressField1.trim().length < 2) {
            return this.formValidation.rkAddressField1Error = true;
        }
        return this.formValidation.rkAddressField1Error = false;
    }

    /**
     * Validate latest city abroad
     * @param addressField2 
     * @returns 
     */
      validateRkAddressField2(addressField2: string) {
        if (addressField2 === null || addressField2.trim().length < 1) {
            return this.formValidation.rkAddressField2Error = false;
        } else if (addressField2.trim().length < 2) {
            return this.formValidation.rkAddressField2Error = true;
        }
        return this.formValidation.rkAddressField2Error = false;
    }

    /**
     * Validate latest country abroad
     * @param addressField3 
     * @returns 
    */
    validateRkAddressField3(addressField3: string) {
        if (addressField3 === null || addressField3.trim().length < 1) {
            return this.formValidation.rkAddressField3Error = false;
        } else if (addressField3.trim().length < 2) {
            return this.formValidation.rkAddressField3Error = true;
        }
        return this.formValidation.rkAddressField3Error = false;
    }

    /**
     * Validate name clarification
     * @param nameClarification 
     * @returns 
     */
    validateRkNameClarification(nameClarification: string) {
        if (nameClarification === null || nameClarification.trim().length < 1) {
            return this.formValidation.rkNameClarificationError = false;
        } else if (nameClarification.trim().length < 2) {
            return this.formValidation.rkNameClarificationError = true;
        }
        return this.formValidation.rkNameClarificationError = false;
    }

    /**
     * Validate last name
     * @param personLastname 
     * @returns 
     */
    validateRkPersonLastname(personLastname: string) {
        if (personLastname === null || personLastname.trim().length < 1) {
            return this.formValidation.rkPersonLastnameError = false;
        } else if (personLastname.trim().length < 2) {
            return this.formValidation.rkPersonLastnameError = true;
        }
        return this.formValidation.rkPersonLastnameError = false;
    }

    /**
     * Validate first name
     * @param personFirstname 
     * @returns 
     */
    validateRkPersonFirstname(personFirstname: string) {
        if (personFirstname === null || personFirstname.trim().length < 1) {
            return this.formValidation.rkpersonFirstNameError = false;
        } else if (personFirstname.trim().length < 2) {
            return this.formValidation.rkpersonFirstNameError = true;
        }
        return this.formValidation.rkpersonFirstNameError = false;
    }

    /**
     * Validate phone number
     * @param phoneDaytime 
     * @returns 
     */
    validateRkPhoneDaytime(phoneDaytime: any) {
        phoneDaytime = phoneDaytime.replaceAll(" ", "")  // strip out all white spaces
        if (phoneDaytime === null || phoneDaytime.trim().length < 1) {
            return this.formValidation.rkPhoneDaytimeError = false;
        } else if (phoneDaytime != null && phoneDaytime.trim().length < 5) {
           return this.formValidation.rkPhoneDaytimeError = true;           
       } else {        
            if (!phoneDaytime.match(/^[0-9-+]+$/g)) {                
                return this.formValidation.rkPhoneDaytimeError = true;
            } else {
                return this.formValidation.rkPhoneDaytimeError = false;                
            }
       }       
    }
    
    /**
     * Validate passport number
     * @param passportNumber 
     * @returns 
     */
    validateRkPassportNumber(passportNumber: string) {
        if (passportNumber === null || passportNumber.trim().length < 1) {
            return this.formValidation.rkPassportNumberError = false;
        } else if (passportNumber.trim().length < 2) {
            return this.formValidation.rkPassportNumberError = true;
        }
        return this.formValidation.rkPassportNumberError = false;
    }
}
